module.exports = __webpack_public_path__ + "img/header-memoireRingsSlim.c1b6fb5.webp";